import CompaniesPage from './CompaniesPage';

export function CompanyTaxesPage() {
  return (
    <CompaniesPage
      basePath="/api/company-taxes"
      title="ບໍລິສັດ (ພາສີ)"
      showCreateChild={false}
      showCreate={false}
    />
  );
}
